import { Injectable } from '@angular/core';
import { BookingService } from './booking2.service';
import { StorageService } from './storage.service';
import { Airport } from '../model/airport';

@Injectable({
  providedIn: 'root'
})
export class BookingPricingService {
  constructor(
    private booking: BookingService,
    private storageService: StorageService
  ) {}

  getServiceTotal(service: any): number {
    const paidPassengers = this.getPaidPassengers(service);

    if (paidPassengers <= 0) {
      return 0;
    }

    const firstPrice = this.toPrice(service?.price);
    const subsequentPrice = this.toPrice(
      service?.priceSubsequent ??
      service?.departurePriceSubsequent ??
      service?.arrivalPriceSubsequent ??
      service?.transitPriceSubsequent ??
      0
    );

    return this.round(
      firstPrice +
      Math.max(paidPassengers - 1, 0) * subsequentPrice
    );
  }

  getCartTotal(): number {
    return this.round(
      this.booking.cartServices().reduce(
        (sum, service) => sum + this.getServiceTotal(service),
        0
      )
    );
  }

  private getPaidPassengers(service: any): number {
    const airport = this.getServiceAirport(service);

    if (!airport) {
      return 1;
    }

    const routeCode =
      this.storageService.getAirportRouteCode(airport);

    const savedForm = routeCode
      ? this.storageService.getAirportBookingForm(routeCode)
      : null;

    const isActiveAirport =
      Number(this.booking.activeAirport()?.id) === Number(airport.id);

    const form = isActiveAirport
      ? this.booking.formData() || savedForm
      : savedForm;

    const passengersState =
      form?.passengersState ||
      this.booking.passengers();

    const adults = Number(passengersState?.adult || 0);
    const children = Number(passengersState?.children || 0);

    return adults + children || 1;
  }

  private getServiceAirport(service: any): Airport | undefined {
    return this.storageService.getAirportsSync().find(
      airport => Number(airport.id) === Number(service.airportId)
    );
  }

  private toPrice(value: unknown): number {
    const price = Number(value);

    return Number.isFinite(price) && price >= 0
      ? price
      : 0;
  }

  private round(value: number): number {
    return Number(value.toFixed(2));
  }
}
